import React, { useContext, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { customFrequencyUtils } from 'app-components/flux/scheduled-transactions';
import { FrequencyContext } from './state';

import { makeStyles } from 'tss-react/mui';

const { ORDINAL_DAYS, sortValuesContainingLast } = customFrequencyUtils;

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  freqDescription: {
    paddingTop: 16,
    paddingBottom: 8,
    fontSize: 12,
  },
  outlinedInput: {
    backgroundColor: theme.palette.background.default,
    minHeight: 48,
    '.MuiOutlinedInput-input': {
      padding: 8,
      '&:focus': {
        backgroundColor: theme.palette.background.default,
      },
    },
  },
  chip: {
    fontSize: 14,
    backgroundColor: theme.palette.background.layer1,
    borderRadius: 20,
    '.MuiChip-deleteIcon': {
      height: 20,
      width: 20,
      color: theme.palette.icon.light,
    },
  },
  errorText: {
    color: theme.palette.error.main,
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function TwiceAMonth() {
  const { state, dispatch, error } = useContext(FrequencyContext);
  const { classes } = useStyles();
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  // @ts-expect-error FIXME TS7006
  const handleSelectChange = (event) => {
    setIsOpen(false); // close dropdown after each selection
    const sorted = event?.target?.value ? sortValuesContainingLast(event.target.value) : [];

    dispatch({ type: 'UPDATE_MONTHLY_BY_MONTHDAY', payload: sorted });
  };

  // @ts-expect-error FIXME TS7006
  const handleDayDelete = (_e, item) => {
    const prop = state.byMonthDay;
    const tempValue = prop?.filter((existing) => existing !== item.value && !(item.value < 0 && existing > 28)) || [];
    const value = tempValue.length === 0 ? undefined : tempValue;
    dispatch({ type: 'UPDATE_MONTHLY_BY_MONTHDAY', payload: value });
  };

  // @ts-expect-error FIXME TS7006
  const renderSelect = (all, selected) => (
    <FormControl id='days-select' sx={{ width: '100%' }}>
      <Select
        sx={{ p: 0 }}
        id='days-select'
        variant='filled'
        multiple
        value={selected}
        open={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        onChange={handleSelectChange}
        error={error}
        input={<OutlinedInput id='select-multiple-chip' className={classes.outlinedInput} />}
        renderValue={(values) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, p: 0 }}>
            {/*
             // @ts-expect-error FIXME TS7006 */}
            {values.map((value) => {
              // @ts-expect-error FIXME TS7006
              const item = all.find((day) => day.value === value) || { name: 'Last', value: -1 };
              return (
                <Chip
                  key={item.value}
                  label={item.name}
                  clickable
                  deleteIcon={<ClearIcon onMouseDown={(event) => event.stopPropagation()} />}
                  className={classes.chip}
                  onDelete={(e) => handleDayDelete(e, item)}
                />
              );
            })}
          </Box>
        )}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              width: 250,
              paddingRight: 8,
            },
            sx: {
              '& .MuiList-root': {
                paddingBottom: 0,
              },
              '& .MuiMenuItem-root[data-value="-1"] ': {
                position: 'sticky',
                borderRadius: 0,
                borderTop: `1px solid ${theme.palette.border.light}`,
                backgroundColor: theme.palette.background.paper,
                bottom: 0,
                mt: 1,
                py: 1,
                px: 2,
                '& div': {
                  width: '100%',
                  borderRadius: 2,
                  px: 2,
                },
              },
              '& .MuiMenuItem-root[data-value="-1"]:hover': {
                borderRadius: 2,
                backgroundColor: theme.palette.action.hover,
                mt: 1,
                py: 1,
                '& div': {
                  backgroundColor: theme.palette.info.light,
                  mt: 0,
                  py: 1,
                },
              },
              '.Mui-selected': {
                borderRadius: '8px !important',
                backgroundColor: `${theme.palette.action.hover} !important`,
              },
              '& .Mui-disabled': {
                opacity: '1 !important',
                color: theme.palette.grey[700],
              },
            },
          },
        }}
      >
        {/*
         // @ts-expect-error FIXME TS7006 */}
        {all.map((day) => {
          const isDisabled = !selected.includes(day.value) && selected.length >= 2;
          return (
            <MenuItem key={day.name} value={day.value} disabled={isDisabled}>
              {day.name}
            </MenuItem>
          );
        })}
      </Select>
      {error && <FormHelperText className={classes.errorText}>Required</FormHelperText>}
    </FormControl>
  );

  return (
    <div id='monthly-recurrence' className={classes.root}>
      <Typography className={classes.freqDescription}>Select two days.</Typography>
      {renderSelect(ORDINAL_DAYS, state.byMonthDay || [])}
    </div>
  );
}

export default TwiceAMonth;
